import L from "leaflet";
import { Marker, Popup, Tooltip } from "react-leaflet";
import {
  ROADS_SOURCE_URL,
  formatTemp,
  formatTraffic,
  formatWind,
  isIcy,
} from "./roads";

// A small chip showing the air temperature, tinted when the road surface is
// freezing or there is a wind alert, so road stations read apart from the
// round air-quality dots
const icon = (station) => {
  const label = station.temp == null ? "–" : `${Math.round(station.temp)}°`;
  const cls = [
    "aq-road",
    isIcy(station) && "aq-road--ice",
    station.alert && "aq-road--alert",
  ]
    .filter(Boolean)
    .join(" ");
  return L.divIcon({
    className: "aq-road-anchor",
    html: `<span class="${cls}">${label}</span>`,
    iconSize: [34, 20],
    iconAnchor: [17, 10],
    popupAnchor: [0, -12],
  });
};

const Row = ({ label, value }) =>
  value == null ? null : (
    <p className="aq-popup__wind">
      {label}: {value}
    </p>
  );

export const RoadStations = ({ stations }) =>
  stations.map((s) => (
    <Marker key={s.id} position={[s.lat, s.lon]} icon={icon(s)} title={s.name}>
      <Tooltip pane="tooltipPane" direction="top" offset={[0, -12]}>
        {s.name}
      </Tooltip>
      <Popup pane="popupPane" closeButton={false} minWidth={220} maxWidth={300}>
        <div className="aq-popup">
          <p className="aq-popup__level">
            {isIcy(s)
              ? "Freezing road surface"
              : s.alert
                ? "Wind alert"
                : "Road weather"}
          </p>
          <h3 className="aq-popup__name">{s.name}</h3>
          <Row label="Air" value={formatTemp(s.temp)} />
          <Row label="Road" value={formatTemp(s.roadTemp)} />
          <Row label="Wind" value={formatWind(s)} />
          <Row
            label="Humidity"
            value={s.humidity == null ? null : `${s.humidity}%`}
          />
          <Row label="Traffic" value={formatTraffic(s)} />
          <p className="aq-popup__links">
            <a href={ROADS_SOURCE_URL} target="_blank" rel="noreferrer">
              umferdin.is
            </a>
          </p>
        </div>
      </Popup>
    </Marker>
  ));
